<app-layout>
    <h1 class="mb-8 font-bold text-3xl">
        <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('admin.languages')">Languages</inertia-link>
        - {{ subTitle }}
    </h1>
    <div class="bg-white rounded shadow overflow-hidden lg:w-1/2">
        <form @submit.prevent="submit">
            <div class="p-8 -mr-6 -mb-8 flex flex-wrap">

                <div class="pr-6 pb-8 w-full">
                    <div class="font-weight-bold text-xl border-b mb-2 pb-4 font-medium">General Information</div>
                </div>

                <text-input v-model="form.name" :error="errors.name" class="pr-6 pb-8 w-full lg:w-1/2" label="Name" />

                <text-input v-model="form.slug" :error="errors.slug" class="pr-6 pb-8 w-full lg:w-1/2" label="Slug (e.g. en, es, de)" />

                <div class="pr-6 pb-8 w-full">
                    <label class="form-label block mr-2 mb-3">Enable Language</label>
                    <t-toggle v-model="form.status" />
                    <div v-if="errors.status" class="form-error text-red-500">{{ errors.status }}</div>
                </div>

                <div class="pr-6 pb-8 w-full">
                    <label class="form-label block mr-2 mb-3">Default Language</label>
                    <t-toggle v-model="form.is_default" />
                    <div v-if="errors.is_default" class="form-error text-red-500">{{ errors.is_default }}</div>
                </div>

            </div>
            <div class="px-8 py-4 bg-gray-100 border-t border-gray-200 flex items-center">
                <button v-if="isEdit" class="focus:outline-none text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete Language</button>
                <loading-button :loading="sending" class="btn-indigo ml-auto" type="submit">
                    <svg v-show="sending" class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    {{ actionButtonTitle }}
                </loading-button>
            </div>
        </form>
    </div>
</app-layout>
